import { Box, Button, Icon, Typography } from "@mui/material";
import React from "react";
import { ButtonDiv, Image } from "./style";

export default function ImageView({ src, preview, setOpen }) {
  const title = () => {
    switch (preview) {
      case 'DOCUMENTO DE IDENTIFICAÇÃO':
        return "Documento-de-Identificacao";
      case 'COMPROVANTE DE RESIDÊNCIA':
        return "Comprovante-de-Residencia";
      case 'COMPROVANTE DE RENDA':
        return "Comprovante-de-Renda";
      case 'FICHA DE INTERESSE':
        return "Ficha-de-Interesse";
      case 'COMPROVANTE ESTADO CIVIL':
        return "Comprovante-Estado-Civil";
      default:
        return preview;
    }
  }

  return (
    <Box
      sx={{
        marginTop: '15px',
        padding: '25px',
        borderRadius: '40px',
        height: 'fitContent',
        background: '#fff',
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
      }}
    >
      <Box sx={{ display: 'flex' }}>
        <a href={src} download={title()}>
          <Button variant="contained" sx={{ color: 'white !important' }}><Icon>download</Icon> Download</Button>
        </a>

        <ButtonDiv style={{ cursor: 'pointer' }} onClick={() => setOpen(false)}>x</ButtonDiv>
      </Box>

      <Box sx={{ textAlign: 'center' }}>
        <Image src={src} alt="selected" />
      </Box>

      <Typography>{preview}</Typography>
    </Box>
  );
}
